export default object => ({
  id: object.id,
  description: object.description,
});
